import Vue from 'vue'

const notification = {
  state: {
    notifications: [],
    selectedNotification: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    notifications(state) {
      return state.notifications
    },
    selectedNotification(state) {
      return state.selectedNotification
    },
    loading(state) {
      return state.searchCount > 0
    },
    hasUnacknowledged(state) {
      return state.notifications.filter((n) => !n.IsAcknowledged).length > 0
    },
    unacknowledgedCount(state) {
      return state.notifications.filter((n) => !n.IsAcknowledged).length
    },
  },

  mutations: {
    notifications(state, payload) {
      state.notifications = payload
    },
    selectedNotification(state, payload) {
      state.selectedNotification = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedNotification(context, payload) {
      context.commit('selectedNotification', payload)
    },
    loadNotifications(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Notification/UnacknowledgedAndRecent'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('notifications', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            // context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedNotification(context, payload) {
      if (
        context.state.selectedNotification &&
        context.state.selectedNotification.ID
      ) {
        context.dispatch(
          'loadSelectedNotification',
          context.state.selectedNotification.ID
        )
      }
    },
    loadSelectedNotification(context, payload) {
      if (
        context.state.selectedNotification &&
        context.state.selectedNotification.ID != payload
      ) {
        context.commit('selectedNotification', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'Notification/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedNotification', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    markUnread(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Notification/Unread/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.get(url).then(
          (res) => {
            // context.dispatch(
            //   'messages/toastMessage',
            //   { color: 'success', message: 'notification updated' },
            //   { root: true }
            // )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            context.dispatch('loadNotifications')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    acknowledge(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Notification/Acknowledge/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.get(url, payload).then(
          (res) => {
            // context.dispatch(
            //   'messages/toastMessage',
            //   { color: 'success', message: 'notification updated' },
            //   { root: true }
            // )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            context.dispatch('loadNotifications')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    updateNotification(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Notification/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'notification updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadNotifications')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createNotification(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Notification`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'notification created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadNotifications')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveNotification(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateNotification', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createNotification', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteNotification(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Notification/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'notification deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadNotifications')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default notification
